import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import ProductImage from '../components/common/ProductImage';
import { useCart } from '../context/CartContext';
import { useIsMobile } from '../hooks/useResponsive';
import toast from 'react-hot-toast';

const V  = '#8B5CF6';
const VD = '#6D28D9';
const VL = '#EDE9FE';
const FAMILLES = ['Oriental', 'Floral', 'Boisé', 'Ambré', 'Frais', 'Épicé', 'Musqué'];
const SORTS = [
  { v: '', l: 'Par défaut' },
  { v: 'price_asc',  l: 'Prix croissant' },
  { v: 'price_desc', l: 'Prix décroissant' },
  { v: 'name',       l: 'Nom A-Z' },
];

export default function CataloguePage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [total, setTotal]       = useState(0);
  const [page, setPage]         = useState(1);
  const [pages, setPages]       = useState(1);
  const [loading, setLoading]   = useState(true);
  const [showFilters, setShowFilters] = useState(false);
  const { addItem } = useCart();
  const isMobile = useIsMobile();

  const famille = searchParams.get('famille') || '';
  const search  = searchParams.get('search')  || '';
  const sort    = searchParams.get('sort')    || '';

  useEffect(() => {
    setLoading(true);
    api.get('/api/products', { params: { famille: famille || undefined, search: search || undefined, page, limit: 12 } })
      .then(r => {
        let list = r.data.products || [];
        if (sort === 'price_asc')  list = [...list].sort((a, b) => (a.variants?.[0]?.price||0)-(b.variants?.[0]?.price||0));
        if (sort === 'price_desc') list = [...list].sort((a, b) => (b.variants?.[0]?.price||0)-(a.variants?.[0]?.price||0));
        if (sort === 'name')       list = [...list].sort((a, b) => a.name.localeCompare(b.name));
        setProducts(list);
        setTotal(r.data.total || list.length);
        setPages(r.data.pages || 1);
      })
      .catch(() => toast.error('Erreur de chargement'))
      .finally(() => setLoading(false));
  }, [famille, search, sort, page]);

  const set = (key, val) => {
    const p = new URLSearchParams(searchParams);
    if (val) p.set(key, val); else p.delete(key);
    setSearchParams(p);
    setPage(1);
    if (isMobile) setShowFilters(false);
  };

  const Filters = () => (
    <div style={{ background: '#FAFAFE', border: '1px solid #EDE9FE', borderRadius: 8, padding: '1.25rem' }}>
      <p style={{ fontSize: 10, letterSpacing: 2, color: V, textTransform: 'uppercase', marginBottom: 14, fontWeight: 600 }}>Filtres</p>
      <input
        placeholder="Rechercher..."
        value={search}
        onChange={e => set('search', e.target.value)}
        style={{ width: '100%', background: '#fff', border: '1px solid #DDD6FE', color: '#111', padding: '10px 12px', fontSize: 13, outline: 'none', borderRadius: 4, marginBottom: 16, boxSizing: 'border-box' }}
      />
      <p style={{ fontSize: 11, color: '#888', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 8 }}>Famille</p>
      <div style={{ display: 'flex', flexDirection: isMobile ? 'row' : 'column', flexWrap: 'wrap', gap: 6, marginBottom: 16 }}>
        <button onClick={() => set('famille', '')} style={{ textAlign: 'left', background: !famille ? V : 'transparent', color: !famille ? '#fff' : '#666', border: `1px solid ${!famille ? V : '#DDD'}`, padding: '7px 12px', cursor: 'pointer', fontSize: 12, borderRadius: 4 }}>
          Toutes
        </button>
        {FAMILLES.map(f => (
          <button key={f} onClick={() => set('famille', f)} style={{ textAlign: 'left', background: famille===f ? V : 'transparent', color: famille===f ? '#fff' : '#666', border: `1px solid ${famille===f ? V : '#DDD'}`, padding: '7px 12px', cursor: 'pointer', fontSize: 12, borderRadius: 4 }}>
            {f}
          </button>
        ))}
      </div>
      <p style={{ fontSize: 11, color: '#888', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 8 }}>Trier par</p>
      <select value={sort} onChange={e => set('sort', e.target.value)}
        style={{ width: '100%', background: '#fff', border: '1px solid #DDD', color: '#111', padding: '10px 12px', fontSize: 13, outline: 'none', borderRadius: 4, boxSizing: 'border-box' }}>
        {SORTS.map(s => <option key={s.v} value={s.v}>{s.l}</option>)}
      </select>
    </div>
  );

  return (
    <div style={{ background: '#fff', minHeight: '100vh', color: '#111' }}>
      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg, #6D28D9, #8B5CF6)', padding: isMobile ? '2rem 1rem' : '3rem 2rem', textAlign: 'center' }}>
        <p style={{ fontSize: 10, letterSpacing: 4, color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', marginBottom: 8 }}>SS PARFUMERIE</p>
        <h1 style={{ fontFamily: 'Georgia, serif', fontSize: isMobile ? 28 : 40, fontWeight: 300, color: '#fff', marginBottom: 8 }}>Notre Catalogue</h1>
        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.75)' }}>{total} références disponibles</p>
      </div>

      {/* Bouton filtres mobile */}
      {isMobile && (
        <div style={{ padding: '1rem', borderBottom: '1px solid #EEE' }}>
          <button onClick={() => setShowFilters(f => !f)} style={{
            width: '100%', background: showFilters ? V : '#fff', color: showFilters ? '#fff' : V,
            border: `1px solid ${V}`, padding: '10px', fontSize: 12, letterSpacing: 2,
            textTransform: 'uppercase', cursor: 'pointer', borderRadius: 6,
          }}>
            {showFilters ? '✕ Fermer les filtres' : '⚙ Filtres & tri'}
          </button>
          {showFilters && <div style={{ marginTop: 12 }}><Filters /></div>}
        </div>
      )}

      <div style={{
        maxWidth: 1200, margin: '0 auto', padding: isMobile ? '1rem' : '2rem',
        display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '220px 1fr', gap: isMobile ? 16 : 32,
      }}>
        {/* Sidebar desktop */}
        {!isMobile && (
          <aside style={{ position: 'sticky', top: 80, alignSelf: 'start' }}>
            <Filters />
          </aside>
        )}

        {/* Grille produits */}
        <main>
          {loading ? (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 16 }}>
              {[...Array(8)].map((_, i) => (
                <div key={i} style={{ border: '1px solid #EEE', borderRadius: 8, overflow: 'hidden' }}>
                  <div style={{ height: 140, background: '#F3F3F3' }} />
                  <div style={{ padding: '1rem' }}>
                    <div style={{ height: 12, background: '#F3F3F3', borderRadius: 4, marginBottom: 8 }} />
                    <div style={{ height: 10, background: '#F3F3F3', borderRadius: 4, width: '60%' }} />
                  </div>
                </div>
              ))}
            </div>
          ) : products.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '4rem 1rem' }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>🔍</div>
              <p style={{ fontFamily: 'Georgia, serif', fontSize: 20, color: '#888' }}>Aucun parfum trouvé</p>
              <button onClick={() => setSearchParams({})} style={{ marginTop: 20, background: V, color: '#fff', border: 'none', padding: '12px 28px', cursor: 'pointer', borderRadius: 4, fontSize: 13 }}>
                Réinitialiser les filtres
              </button>
            </div>
          ) : (
            <>
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(200px, 1fr))', gap: isMobile ? 12 : 20 }}>
                {products.map(p => {
                  const v = p.variants?.[0];
                  return (
                    <div key={p._id} style={{ border: '1px solid #EEE', borderRadius: 8, overflow: 'hidden', background: '#fff', transition: 'all .2s' }}
                      onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 6px 24px rgba(139,92,246,0.12)'; e.currentTarget.style.borderColor = '#DDD6FE'; }}
                      onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.borderColor = '#EEE'; }}>
                      <Link to={`/produit/${p._id}`} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
                        <ProductImage images={p.images} name={p.name} height={isMobile ? 140 : 180} />
                      </Link>
                      <div style={{ padding: isMobile ? '0.75rem' : '1rem' }}>
                        {p.badge && <span style={{ fontSize: 9, background: VL, color: V, padding: '2px 8px', borderRadius: 2, letterSpacing: 1 }}>{p.badge}</span>}
                        <Link to={`/produit/${p._id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                          <h3 style={{ fontFamily: 'Georgia, serif', fontSize: isMobile ? 13 : 15, marginTop: 6, marginBottom: 4, lineHeight: 1.3 }}>{p.name}</h3>
                        </Link>
                        <p style={{ fontSize: 10, color: '#999', marginBottom: 10 }}>{p.famille}</p>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 6 }}>
                          <span style={{ color: V, fontSize: isMobile ? 14 : 16, fontWeight: 600 }}>{v?.price} <span style={{ fontSize: 10, fontWeight: 400 }}>FCFA</span></span>
                          <button onClick={() => { addItem(p, v?.size); toast.success(`${p.name} ajouté`); }}
                            style={{ background: V, color: '#fff', border: 'none', padding: isMobile ? '6px 10px' : '7px 14px', fontSize: 10, letterSpacing: 1, textTransform: 'uppercase', cursor: 'pointer', borderRadius: 4 }}>
                            + Panier
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              {pages > 1 && (
                <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 32, flexWrap: 'wrap' }}>
                  {[...Array(pages)].map((_, i) => (
                    <button key={i} onClick={() => setPage(i+1)} style={{
                      width: 36, height: 36, border: `1px solid ${page===i+1 ? V : '#DDD'}`,
                      background: page===i+1 ? V : '#fff', color: page===i+1 ? '#fff' : '#666',
                      cursor: 'pointer', fontSize: 13, borderRadius: 4,
                    }}>{i+1}</button>
                  ))}
                </div>
              )}
            </>
          )}
        </main>
      </div>
    </div>
  );
}
